// export const API_URL = "https://sadguru.hrms.iwebwiser.in/SHRMS/api/v1"; // Dev Url
export const API_URL = "https://sssst.hrms.iwebwiser.in/SHRMS/api/v1"; // Production Url
// export const API_URL = "http://82.29.165.216:3211/SHRMS/api/v1"; // local
// export const API_URL = "https://x7dj7hh5-3211.inc1.devtunnels.ms/SHRMS/api/v1"; // local

export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || "/";

export const API_ENDPOINT = {
  roles: "/roles",
  auth: "/auth",
  admin: "/admin",
  users: "/user",
  Department: `/department`,
  Branch: `/branch`,
  shift: `/shift`,
  oauth: "/oauth",
  clients: "/oauth/clients",
  Designation: "/designation",
  holiday: "/settings/holiday",
  site: `/site`,
  Campus: `/campus`,
  user: "/user",
  leave: "/leave",
  attendance: "/attendance",
  wfh: "/wfh",
  fileUpload: "/file-upload",
  transactions: "/transactions",

  investments: "/investments",
  referrals: "/referrals",
  ranks: "/ranks",
  royalty: "/royalty",
  notification: "/notification",
  createNotification: "/notification/create",
  withdrawals: "/withdrawals",
  adminSettings: "/admin/settings",
  CompanyDocument: "/company-document",

  // Site
  settings: "/settings",
  stores: "/store",
  updateStore: "/store/update",
  varients: "/product-variants",
  addons: "/product-addons",
  categories: "/categories",
  products: "/products",
  discounts: "/discounts",
  coupons: "/coupons",
  orders: "/order",
  updateOrderStatus: "/order/update-status",
  assignDriver: "/order/assign-driver",
  drivers: "/driver",
  createDriver: "/user/create-driver",
  updateDriverProfile: "/user/update-driver",
  review: "/review",
  reviewAction: "/review/action",
  homeLayout: "/home-layout",
  storeDashboard: "/store/dashboard",
  tags: "/tags",
  cashSettlement: "/cash-settlement",
  checkoutMessage: "/checkout-message",
  zones: "/zones",
  return: "/return-requests",
  returnReason: "/return-requests/reason",
  media: "/media",
  reportsDashboard: "/reports/dashboard",
  reportsAnalytics: "/reports/analytics",
  payouts: "/payout",
  dashboard: "/dashboard",
  payment: "/payment",
  wallet: "/wallet",
  editProfile: "/user/edit-profile",

  // OD
  od: "/outdoor-duty",

  // Regularization
  regularization: "/regularization",

  // team-lead
  teamLead: "/team-lead",
  //organisationStructure
  organisationStructure: "/user/organisation-structure",

  //report
  report: "/report",

  //salary head
  salaryHead: "/salary-head",

  //branch salary head
  branchSalaryHead: "/branch-salary-head",
  BranchSalaryHeadTemplates: "/branch-wise-salary-import-template",
  branchWiseSalaryImport: "/branch-wise-salary-import",
  branchWiseUserSalary: "/branch-wise-user-salary",
  userSalary: "/user-salary",

  // payslip
  getMonthlyUserSalaryList: "/get-monthly-user-salary-list",
  userMonthlySalaryOverview: "/user-monthly-salary-overview",
  generateSalarySlip: "/generate-salary-slip",
  salaryChallan: "/salary-challan",

  // dashboard
  getDashboard: "/dashboard",

  // asset
  asset: "/asset",
  assetRequest: "/asset-request",

  // tax declaration
  userTaxDeclaration: "/user-tax-declaration",
};
